/* 基地排车 */
import request from '@/utils/http';

const API_RECEIPT = '/api-tms';
// const API_RECEIPT = '';

/* 获取待调度列表数据 */
export const getSourceRoot = (params) => {
    return request({
        url: `${API_RECEIPT}/transport/grouppolicy/list`,
        method: 'post',
        data: params
    });
};

/* 待发车列表 */
export const getTargetRoot = (data) => {
    return request({
        url: `${API_RECEIPT}/dispatch/list`,
        method: 'post',
        data
    });
};

/* 下表格头部查看详情 */
export const getDetailStatistics = (data) => {
    return request({
        url: `${API_RECEIPT}/transport/itemdeail/count`,
        method: 'post',
        data
    });
};

/* 根据调度列表点击参数获取上表格数据 */
export const getSourceData = (params) => {
    return request({
        url: `${API_RECEIPT}/transport/list/bygrouppolicy`,
        method: 'post',
        data: params
    });
};

/* 根据待发车列表点击参数获取下表格数据 */
export const getTargetData = (data) => {
    return request({
        url: `${API_RECEIPT}/transport/list/sort`,
        method: 'post',
        data
    });
};

/* 查询分拨仓 */
export const getStorageData = (params) => {
    return request({
        url: `${API_RECEIPT}/trunk/dispatch/distribution/search`,
        method: 'get',
        params
    });
};

/* 确认分拨(单个) */
export const getAllocate = (data) => {
    return request({
        url: `${API_RECEIPT}/dispatch/distribution/update/${data.taskNo}`,
        method: 'put',
        data
    });
};

/* 确认分拨(批量) */
export const getAllocatesBatch = (data) => {
    return request({
        url: `${API_RECEIPT}/dispatch/trunk/distribution/update/batch`,
        method: 'post',
        data
    });
};

/* 取消分拨 */
export const getCancleAllocate = (data) => {
    return request({
        url: `${API_RECEIPT}/dispatch/distribution/cancel`,
        method: 'put',
        data
    });
};

// 下发
export const issueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/issueCarrier`,
        method: 'put',
        data
    });
};

// 撤回
export const confirmIssueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/confirmIssueCarrier`,
        method: 'put',
        data
    });
};

// 排车弹窗保存(加减单确认)
export const dispatchTrunkSave = (data) => {
    return request({
        url: `${API_RECEIPT}/dispatch/trunk/save`,
        method: 'post',
        data
    });
};

// 装车排序
export const loadSeqUpdateByTaskNo = (data) => {
    return request({
        url: `${API_RECEIPT}/transportExtend/loadSeqUpdateByTaskNo`,
        method: 'post',
        data
    });
};

// 新装车排序-获取仓库信息
export const searchPark = (data) => {
    return request({
        url: `/api-antms/api-dispatch/transportExtends/searchPark`,
        method: 'post',
        data
    });
};

// 新装车排序-修改保存
export const batchUpdateParkSequence = (data) => {
    return request({
        url: `/api-antms/api-dispatch/transportExtends/batchUpdateParkSequence`,
        method: 'post',
        data
    });
};

// 新装车排序-排车校验装车顺序，试点仓库的TK单，必须操作装车排序
export const checkSequence = (data) => {
    return request({
        url: `/api-antms/api-converged/dispatch/trunk/check`,
        method: 'post',
        data
    });
};
